export default __webpack_public_path__ + "static/media/logo.07b000f8.png";